<div class="login-body">
    <div class="login-panel p-fluid">
        <div class="p-grid">
            <div class="logo-container">
                <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'" alt="logo-dark" />
                <h1>Recover Organization ID</h1>
            </div>
            <div class="p-col-12">
                <div style="text-align: center">Please enter your email to recover your organization ID!</div> 
                <hr>               
            </div>
           
            <div class="p-col-12">
                <form>
                    <div class="form-group p-mb-2">
                        <label for="email"><strong>Email</strong><span style="color: red;"> *</span></label>
                        <input pInputText type="text" [ngStyle]="{'width': '100%'}" [formControl]="email"
                            [ngClass]="{ 'is-invalid': submitted && email.invalid }" placeholder="Enter your email" />
                    </div>
                   
                    <div class="form-group p-mb-2">
                        <p-button type="submit" [disabled]="email.invalid" label="Submit" icon="pi pi-user"
                        styleClass="w-10rem mx-auto" [rounded]="true" severity="info" (click)="onSubmit()"></p-button>
                    </div>
                    <div class="form-group p-text-center p-mt-3">
                        <p-button 
                            label="Back to Login Page" 
                            icon="pi pi-arrow-left"  
                            [rounded]="true" 
                            severity="info" 
                            [link]="true"
                            [routerLink]="['/login']">
                        </p-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<p-toast [baseZIndex]="999999"></p-toast>